const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const getFormattedTime = (time) => {
  const TimeArr = time.split(":");
  if (!TimeArr?.length || TimeArr?.length < 2) return "";
  let timeSymbol = "am";
  if (TimeArr[0] > 11) timeSymbol = "pm";
  return `${TimeArr[0]}:${TimeArr[1]} ${timeSymbol}`;
};

export const formatDate = (initialDate) => {
  const myDate = new Date(initialDate);
  return `${monthNames[myDate.getMonth()]} ${myDate.getDate()}`;
};

export const formatDateAndTime = (initialDateTimeString, separator) => {
  const dateTimeArr = initialDateTimeString?.split(separator);
  let timeString = "";
  if (!dateTimeArr?.length) return "-";
  else if (dateTimeArr?.length === 2)
    timeString = getFormattedTime(dateTimeArr[1]);
  return `${formatDate(dateTimeArr[0])}  ${timeString ? " " + timeString : ""}`;
};

export const getCurrentTime = () => {
  const date = new Date();
  const am_pm = date.getHours() > 11 ? "PM" : "AM";
  let hour = am_pm === "AM" ? date.getHours() : date.getHours() - 12;
  if (hour === 0) hour = "12";
  return `${hour}:${
    date.getMinutes() > 9 ? "" : "0"
  }${date.getMinutes()} ${am_pm}`;
};
